export default "__VITE_ASSET__6df7d4af__"